// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router-link-exact-active[data-v-c5e56f46] {\n  border-bottom-color: #59af54 !important;\n  border-bottom-width: 3px !important;\n  border-bottom-style: solid !important;\n  margin-bottom: -2px !important;\n  color: #59af54 !important;\n}\n.router-link-exact-active p[data-v-c5e56f46] {\n  color: #59af54 !important;\n}\n.checkout-tab-button[data-v-c5e56f46] {\n  padding: 13px 0px 13px 0px;\n  display: block;\n  font-size: 14px;\n  color: lightgrey;\n  margin-bottom: 0px;\n}", ""]);
// Exports
module.exports = exports;
